<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">자주하는 질문</span>
            <span class="txt">센터 admin에 보여질 자주하는 질문사항과 답변 게시글을 작성 할 수 있습니다.</span>
        </div>
        <loading-spinner v-if="!questionList"></loading-spinner>
        <div v-else class="com-table-content">
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link v-if="careAuth === true" class="com-btn blue" to="/madmin/question/edit">
                        글쓰기
                    </router-link>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 120px" />
                    <col style="width: 1000px" />
                    <col style="width: 205px" />
                    <col style="width: 205px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>등록일</th>
                        <th>제목</th>
                        <th>글쓴이</th>
                        <th>조회수</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(question, index) in questionList" :key="index">
                        <td>{{ question.c_cre_dt | timestampFilter }}</td>
                        <td>
                            <router-link :to="`/madmin/question/detail/${question.c_id}`" class="ic-link">
                                <span class="ic">{{ question.c_cate_nm }}</span>
                                <span
                                    :class="{
                                        txt: true,
                                        red: question.c_top_fix_yn === true,
                                        new: newPost(question.c_cre_dt),
                                    }"
                                >
                                    {{ question.c_title }}
                                </span>
                            </router-link>
                        </td>
                        <td>{{ question.c_cre_nm === 'root@root.com' ? '핏투데이케어' : question.c_cre_nm }}</td>
                        <td>{{ question.c_view_cnt }}</td>
                    </tr>
                    <tr v-if="questionList.length === 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link v-if="careAuth === true" class="com-btn blue" to="/madmin/question/edit">
                        글쓰기
                    </router-link>
                </div>
            </div>
        </div>
        <b-pagination
            v-model="pagingInfo.page"
            :per-page="pagingInfo.limit"
            :total-rows="pagingInfo.totalItems"
            align="center"
            aria-controls="my-table"
            first-class="first"
            last-class="last"
            next-class="next"
            prev-class="prev"
            @change="handlerPagenation($event)"
        ></b-pagination>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import { calcNewPost } from '@/assets/js/validation.js';
import { pagingInfo } from '@/assets/js/common';

export default {
    name: 'questionList',
    props: {},
    computed: {
        isCareAdmin() {
            return this.$store.getters['auth/isCareAdmin'];
        },
        isSystemAdmin() {
            return this.$store.getters['auth/isSystemAdmin'];
        },
    },
    data() {
        return {
            careAuth: false,
            questionList: null,
            pagingInfo: { ...pagingInfo },
        };
    },
    mounted() {
        if (this.isCareAdmin || this.isSystemAdmin) {
            // 케어 권한 확인
            this.careAuth = true;
        }
        this.fetchQuestionList();
    },
    methods: {
        // 최근 게시글(N) 표시 위한 날짜 계산, true면 새 게시글
        newPost(creDt) {
            return calcNewPost(creDt);
        },

        // 자주하는 질문 목록 Fetch
        async fetchQuestionList() {
            try {
                const { data } = await this.getQuestionList();
                this.setPageParams(data);
                this.questionList = data.items;
            } catch (error) {
                console.log(error);
            }
        },

        // 자주하는 질문 목록 조회 API 호출
        getQuestionList() {
            return api.get('/admin/api/ft/board/faq', {
                params: {
                    ...this.pagingInfo,
                },
            });
        },

        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.fetchQuestionList();
        },

        // 페이징 Param set
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
    },
};
</script>
<style lang="scss"></style>
